<my-select-checkbox-all
  [(ngModel)]="selectedCategories"
  (ngModelChange)="onModelChange()"
  [availableItems]="availableCategories"
  i18n-placeholder placeholder="Add a new category"
  [allGroupLabel]="allCategoriesGroup"
>
</my-select-checkbox-all>
